<template>
  <v-layout>
    <v-flex>
      <v-layout>
        <v-flex xs12>
          <h1 class="headline">Nominal Codes</h1>
        </v-flex>
      </v-layout>
      <v-card>
        <v-container fluid grid-list-md v-for="(nc,key) in nominalCodesArray" :key="key">
          <h3 class="subtitle-1">{{nc.supplierType}}</h3>
          <v-layout row wrap>
            <v-flex sm6>
              <v-text-field label="Sale Code" v-model="nc.salesCode" :outlined="outlinedInputs"></v-text-field>
            </v-flex>
            <v-flex sm6>
              <v-text-field
                label="Purchase Code"
                v-model="nc.purchaseCode"
                :outlined="outlinedInputs"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
      <v-container>
        <v-layout justify-center>
          <v-btn color="primary" @click="saveNominalCodes">Save Changes</v-btn>
        </v-layout>
      </v-container>
    </v-flex>
    <div v-if="debug">{{nominalCodesArray}}</div>
  </v-layout>
</template>

<script>
import {
  ALL_NOMINAL_CODES_SEARCH_QUERY,
  NOMINAL_CODE_UPDATE_MUTATION
} from "../../../../constants/graphql";

export default {
  name: "NominalCodes",

  data() {
    return {
      nominalCodes: {},
      nominalCodesArray: [],
      debug: false,
      skipLoad: false
    };
  },

  watch: {
    nominalCodes(data) {
      this.skipLoad = true;
      data.edges.map(nc => {
        let code = { ...nc.node };
        delete code.__typename;
        if (code.supplierType != "UNSET") {
          this.nominalCodesArray.push(code);
        }
      });
    }
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    }
  },

  methods: {
    saveNominalCodes() {
      for (let i = 0; i < this.nominalCodesArray.length; i++) {
        let mutation = NOMINAL_CODE_UPDATE_MUTATION;
        this.$apollo
          .mutate({
            mutation: mutation,
            variables: {
              ...this.nominalCodesArray[i]
            }
          })
          .then(this.saveGqlObjectHandler, this.saveGqlObjectErrorHandler);
      }
    },
    saveGqlObjectHandler(result) {
      this.$store.dispatch("showAppSnackbar", { msg: "Nominal codes saved." });
    },
    saveGqlObjectErrorHandler(err) {
      this.$store.dispatch("showAppSnackbar", {
        msg: err.graphQLErrors[0].message,
        color: "error"
      });
    }
  },

  apollo: {
    nominalCodes: {
      query: ALL_NOMINAL_CODES_SEARCH_QUERY,
      fetchPolicy: "network-only",
      skip() {
        return this.skipLoad;
      },
      result({ data, loader, networkStatus }) {}
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/gt/admin/service-types/NominalCodes.vue